import { api } from "../Apis/interceptor";

export const getByYear = function (customer_id, year) {
  return api.get("/api/v1/benchmark/" + customer_id + "/" + year);
};

export const saveUpdate = function (customer_id, benchmarkData) {
  return api.put("/api/v1/updateBenchmark/" + customer_id, benchmarkData);
};

export const getyears = function (customer_id, year) {
  return api.get("/api/v1/benchmarkinyears/" + customer_id + "/" + year);
};

export const getSectorYears = function (customer_id, year) {
  return api.get("/api/v1/benchmarkSectors/" + customer_id + "/" + year);
};

export const getInavlidBenchmarkExcel = function (token, fileName) {
  window.open(
    "/api/v1/getInavlidBenchmarkExcel?token=" + token + "&fileName=" + fileName
  );
};
